export class uuid extends String {}